import { Card } from "react-bootstrap";
import { useRouteLoaderData } from "react-router-dom";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useMemo, useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { barOption } from "../chartOptions";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";

ChartJS.register(ArcElement, Tooltip, Legend, annotationPlugin, ChartDataLabels);

export default function Overlap50Chart({ data, loading, error }) {
    const { radios, competitorRadios } = useRouteLoaderData("root");
    const [resolvedRadios, setResolvedRadios] = useState([]);

    useEffect(() => {
        async function resolveRadios() {
            setResolvedRadios((await radios).data.concat((await competitorRadios).data));
        }
        if (radios && competitorRadios) resolveRadios();
    }, [radios, competitorRadios]);

    const chartData = useMemo(() => {
        if (data) {
            const commonPercentage = ((data.common * 100) / (data.unique + data.common)).toFixed(0);
            return {
                labels: [
                    `Unique ${resolvedRadios.find(x => x.radio_id === data.radio_id)?.radio_name ?? "Unknown Radio"}`,
                    `In Common ${commonPercentage}%`,
                    `Unique ${resolvedRadios.find(x => x.radio_id === data.competitor_id)?.radio_name ?? "Unknown Competitor"}`,
                ],
                datasets: [
                    {
                        type: "bar",
                        backgroundColor: ["#7BA7CC", "#396A93", "#BBE2E8"],
                        data: [data.unique, data.common, data.unique_competitor],
                    },
                ],
            };
        }
    }, [data, resolvedRadios]);

    return (
        <Card>
            <Card.Header className="text-center">All Songs Overlap</Card.Header>
            <Card.Body className="card-dashboard-music-chart d-flex justify-content-center align-items-center">
                {loading ? <LoadingIndicator width={75} /> : error ? <ErrorResponse errorCode={error} /> : data && <Bar data={chartData} options={barOption} />}
            </Card.Body>
        </Card>
    );
}
